import { EnvironmentProviders, Provider } from '@angular/core';
import { provideModuleWidgets } from '@softapps/core';
import { dashboardWidgets } from '../../dashboard.widgets';

// legacy path only — the federation shell registers these via ./ModuleWidgets
export function provideKundeninfoWidget(): Array<Provider | EnvironmentProviders> {
  return provideModuleWidgets(dashboardWidgets());
}
